const allowedMarkdownLinkSchemes = new Set(["http:", "https:", "mailto:"]);
const schemePattern = /^([a-z][a-z\d+.-]*):/i;

function hasControlCharacter(value: string) {
  return [...value].some((character) => {
    const code = character.charCodeAt(0);
    return code <= 31 || code === 127;
  });
}

export function isSafeMarkdownLink(value: string): boolean {
  const link = value.trim();
  if (
    !link ||
    hasControlCharacter(link) ||
    link.startsWith("//") ||
    link.startsWith("\\\\")
  ) {
    return false;
  }

  const scheme = schemePattern.exec(link)?.[1];
  if (!scheme) return true;

  try {
    const url = new URL(link);
    return allowedMarkdownLinkSchemes.has(url.protocol);
  } catch {
    return false;
  }
}
